export const COUNTERTOP_TEXTURE_DIMENSION = 36;
export const COUNTERTOP_DEFAULT_THICKNESS = 1.25;
export const COUNTERTOP_DEFAULT_KEY = 'chiseledsmoky';
export const COUNTERTOP_NONE_KEY = 'none';
export const COUNTERTOP_INVALID_KEY = 'invalid-or-missing';
export const COUNTERTOP_MOK_KEY_PREFIX = 'moks|';
export const COUNTERTOP_MIN_THICKNESS = 0.5;
export const COUNTERTOP_MAX_THICKNESS = 3.0;
